import { Component } from '@angular/core';

@Component({
  selector: 'skeleton-estadisticas-efectividad',
  templateUrl: 'skeleton-estadisticas-efectividad.html'
})
export class SkeletonEstadisticasEfectividadComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/skeleton-estadisticas-efectividad/skeleton-estadisticas-efectividad.ts